import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const HAS_CUSTOMER = "has_customer";
const NO_CUSTOMER = "no_customer";

const options: FilterMultiselectOption[] = [
    {
        value: HAS_CUSTOMER,
        label: "Has billable customer",
        searchableLabel: "has billable customer",
    },
    {
        value: NO_CUSTOMER,
        label: "Does not have billable customer",
        searchableLabel: "does not have billable customer",
    },
];

function customerPresenceFromSelection(selected: FilterMultiselectValue[]): {
    hasCustomer: true | undefined;
    withEmptyCustomer: true | undefined;
} {
    const isHasCustomerSelected = selected.includes(HAS_CUSTOMER);
    const isNoCustomerSelected = selected.includes(NO_CUSTOMER);
    if (isHasCustomerSelected === isNoCustomerSelected) {
        return {
            hasCustomer: undefined,
            withEmptyCustomer: undefined,
        };
    }
    return isHasCustomerSelected
        ? {
              hasCustomer: true,
              withEmptyCustomer: undefined,
          }
        : {
              hasCustomer: undefined,
              withEmptyCustomer: true,
          };
}

export const TemplateCustomerFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value: FilterMultiselectValue[] = [
        ...(filters.hasCustomer ? [HAS_CUSTOMER] : []),
        ...(filters.withEmptyCustomer ? [NO_CUSTOMER] : []),
    ];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(selected) =>
                    onChange({
                        ...customerPresenceFromSelection(selected),
                        customerIds: undefined,
                    })
                }
                name="templateCustomer"
                onBlur={noop}
            />
        </div>
    );
};
